import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ReactComponent as IconAsc } from "../../../assets/icon/icon-asc.svg"
import { ReactComponent as IconDesc } from "../../../assets/icon/icon-desc.svg"
import StaticsProduceSkus from './StaticsProduceSkus'
import { Link } from "react-router-dom"

class StaticsProduce2D extends Component {
    _onClick = (key, sort) => {
        const { onChangeSort } = this.props

        if (typeof onChangeSort === 'function') {
            onChangeSort(key, sort)
        }
    }

    _calculatorTotalArray = (arrTotal, key) => {
        return arrTotal.reduce((accumulator, currentValue) => accumulator + currentValue[key], 0)
    }

    _getTotal = (data, key) => {
        if (data.find(i => i[key] >= 0)) {
            return this._calculatorTotalArray(data, key) > 0
                ? this._calculatorTotalArray(data, key)
                : '-'
        }
    }

    render() {
        const { data2D, sort, desc, loading, error } = this.props

        return (
            <div className="StaticsProduce2D">
                <div className="header-title d-flex justify-content-between align-items-center mb-3">
                    <h5 className='mb-0'>Sản phẩm 2D</h5>
                    <StaticsProduceSkus {...this.props} typeSku="2D" />
                </div>
                <div className="data-content">
                    <table className='table table-bordered'>
                        <thead>
                            <tr>
                                <th>SKU</th>
                                <th className='Pending CustomHead' onClick={() => this._onClick('pending', !desc)}>
                                    Pending
                                    <span className={`Sort ${sort === 'pending' ? 'active' : ''} ${desc}`}>
                                        <IconAsc />
                                        <IconDesc />
                                    </span>
                                </th>
                                <th className='InProduction CustomHead'
                                    onClick={() => this._onClick('in_production', !desc)}>
                                    In production
                                    <span className={`Sort ${sort === 'inProduction' ? 'active' : ''} ${desc}`}>
                                        <IconAsc />
                                        <IconDesc />
                                    </span>
                                </th>
                                <th className='Completed CustomHead' onClick={() => this._onClick('completed', !desc)}>
                                    Hoàn thành
                                    <span className={`Sort ${sort === 'completed' ? 'active' : ''} ${desc}`}>
                                        <IconAsc />
                                        <IconDesc />
                                    </span>
                                </th>
                                <th className='Labelled CustomHead' onClick={() => this._onClick('labelled', !desc)}>
                                    Labelled
                                    <span className={`Sort ${sort === 'labelled' ? 'active' : ''} ${desc}`}>
                                        <IconAsc />
                                        <IconDesc />
                                    </span>
                                </th>
                                <th className='Total CustomHead' onClick={() => this._onClick('total', !desc)}>
                                    Tổng
                                    <span className={`Sort ${sort === 'total' ? 'active' : ''} ${desc}`}>
                                        <IconAsc />
                                        <IconDesc />
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                !!error && <tr>
                                    <td colSpan={6} className='text-danger text-left'>{error}</td>
                                </tr>
                            }

                            {
                                !!loading && <tr>
                                    <td colSpan={6} className='text-left'>Loading...</td>
                                </tr>
                            }

                            {
                                !!data2D && data2D.length > 0 &&
                                <tr className='Total2d'>
                                    <td className='Sku'></td>
                                    <td className='Pending'>{this._getTotal(data2D, 'pending')}</td>
                                    <td className='InProduction'>{this._getTotal(data2D, 'in_production')}</td>
                                    <td className='Completed'>{this._getTotal(data2D, 'completed')}</td>
                                    <td className='Labelled'>{this._getTotal(data2D, 'labelled')}</td>
                                    <td className='Total'>{this._getTotal(data2D, 'total')}</td>
                                </tr>
                            }

                            {
                                !!data2D && data2D.length > 0 ? data2D.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className='Sku'>
                                                <Link to={{
                                                    pathname: '/admin',
                                                    search: `?products.type=${item.sku}`
                                                }}>
                                                    {item.sku}
                                                </Link>
                                            </td>
                                            <td className='Pending'>
                                                <Link to={{
                                                    pathname: '/admin',
                                                    search: `?products.type=${item.sku}&production_status=pending`
                                                }}>
                                                    {item.pending === 0 ? '-' : item.pending}
                                                </Link>
                                            </td>
                                            <td className='InProduction'>
                                                <Link to={{
                                                    pathname: '/admin',
                                                    search: `?products.type=${item.sku}&production_status=in_production`
                                                }}>
                                                    {item.in_production === 0 ? '-' : item.in_production}
                                                </Link>

                                            </td>
                                            <td className='Completed'>{item.completed === 0 ? '-' : item.completed}</td>
                                            <td className='Labelled'>
                                                <Link to={{
                                                    pathname: '/admin',
                                                    search: `?products.type=${item.sku}&production_status=labelled`
                                                }}>
                                                    {item.labelled === 0 ? '-' : item.labelled}
                                                </Link>

                                            </td>
                                            <td className='Total'>
                                                <Link to={{
                                                    pathname: '/admin',
                                                    search: `?products.type=${item.sku}`
                                                }}>
                                                    {item.total === 0 ? '-' : item.total}
                                                </Link>
                                                
                                            </td>
                                        </tr>
                                    )
                                }) : 
                                (<tr>
                                    <td colSpan={6} className='text-left'>No data</td>
                                </tr>)
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

StaticsProduce2D.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    data2D: PropTypes.array.isRequired,
    sort: PropTypes.string,
    desc: PropTypes.bool,
    onChangeSort: PropTypes.func.isRequired,
    onChangeListSku: PropTypes.func.isRequired
}

export default StaticsProduce2D